/**
 * Compact money for KPI tiles (GRW-16; also GRW-25). Amounts are integer cents
 * (proto int64 arrives as bigint). Under 10 of a unit one decimal is kept
 * ("$1.2M"), otherwise whole units ("$104M"); thousands are whole ("$850K").
 */ function toDollars(cents) {
    return Number(cents) / 100;
}
function split(dollars) {
    const abs = Math.abs(dollars);
    const scaled = (divisor, unit)=>{
        const value = dollars / divisor;
        const rounded = Math.abs(value) < 10 ? Math.round(value * 10) / 10 : Math.round(value);
        return {
            amount: String(rounded),
            unit
        };
    };
    if (abs >= 1e9) return scaled(1e9, 'B');
    if (abs >= 1e6) return scaled(1e6, 'M');
    if (abs >= 1e3) return {
        amount: String(Math.round(dollars / 1e3)),
        unit: 'K'
    };
    return {
        amount: String(Math.round(dollars)),
        unit: ''
    };
}
/** "$850K", "$1.2M", "$104M", "$2.5B". */ export function formatMoneyCompact(cents) {
    const { amount, unit } = split(toDollars(cents));
    return `$${amount}${unit}`;
}
/**
 * "$104–112M" (en dash, one unit when both ends share it), "$850K–$1.2M" when
 * the units differ, a single value when the ends round to the same figure.
 */ export function formatMoneyRange(lowCents, highCents) {
    const low = split(toDollars(lowCents));
    const high = split(toDollars(highCents));
    if (low.amount === high.amount && low.unit === high.unit) return `$${low.amount}${low.unit}`;
    if (low.unit === high.unit) return `$${low.amount}–${high.amount}${high.unit}`;
    return `$${low.amount}${low.unit}–$${high.amount}${high.unit}`;
}
